import { render, staticRenderFns } from "./two_part_image_one_button.vue?vue&type=template&id=621e9a8a&"
import script from "./two_part_image_one_button.vue?vue&type=script&lang=js&"
export * from "./two_part_image_one_button.vue?vue&type=script&lang=js&"
import style0 from "./two_part_image_one_button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports